"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Avatar = exports.AvatarCircle = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var classnames_1 = require("classnames");
var Typography_1 = require("../Typography");
var sizeMap = {
    sm: (0, classnames_1.default)(' squid-w-component-avatar-size-sm ', ' squid-h-component-avatar-size-sm '),
    md: (0, classnames_1.default)(' squid-w-component-avatar-size-md ', ' squid-h-component-avatar-size-md '),
    lg: (0, classnames_1.default)(' squid-w-component-avatar-size-lg ', ' squid-h-component-avatar-size-lg '),
    xl: (0, classnames_1.default)(' squid-w-component-avatar-size-xl ', ' squid-h-component-avatar-size-xl '),
    '2xl': (0, classnames_1.default)(' squid-w-component-avatar-size-2xl ', ' squid-h-component-avatar-size-2xl '),
};
var initialComponentMap = {
    sm: function (text) { return (0, jsx_runtime_1.jsx)(Typography_1.Caption, { children: text }); },
    md: function (text) { return (0, jsx_runtime_1.jsx)(Typography_1.Label, __assign({ strong: true }, { children: text })); },
    lg: function (text) { return ((0, jsx_runtime_1.jsx)(Typography_1.Heading, __assign({ variant: "sm", as: 'span' }, { children: text }))); },
    xl: function (text) { return ((0, jsx_runtime_1.jsx)(Typography_1.Heading, __assign({ variant: "md", as: 'span' }, { children: text }))); },
    '2xl': function (text) { return ((0, jsx_runtime_1.jsx)(Typography_1.Heading, __assign({ variant: "md", as: 'span' }, { children: text }))); },
};
var getInitials = function (name) {
    return name
        .split(' ')
        .map(function (n) { return n[0]; })
        .slice(0, 2)
        .join('')
        .toUpperCase();
};
var AvatarCircle = function (_a) {
    var src = _a.src, fullName = _a.fullName, size = _a.size;
    var sizeClass = sizeMap[size];
    var ringClass = (0, classnames_1.default)(' squid-ring ', ' squid-ring-core-color-neutral-white ');
    if (src) {
        return ((0, jsx_runtime_1.jsx)("img", { className: (0, classnames_1.default)('squid-object-cover', 'squid-rounded-component-avatar-border-radius', 'squid-inline-block', sizeClass, ringClass), src: src, alt: fullName }));
    }
    return ((0, jsx_runtime_1.jsx)("span", __assign({ className: (0, classnames_1.default)(sizeClass, ringClass, 'squid-text-alias-color-text-weaker', 'squid-inline-flex', 'squid-items-center', 'squid-justify-center', 'squid-rounded-component-avatar-border-radius', 'squid-bg-alias-color-bg-neutral') }, { children: initialComponentMap[size](getInitials(fullName)) })));
};
exports.AvatarCircle = AvatarCircle;
var Avatar = function (_a) {
    var displayFullName = _a.displayFullName, description = _a.description, fullName = _a.fullName, _b = _a.size, size = _b === void 0 ? 'md' : _b, src = _a.src;
    var avatarProps = { size: size, src: src, fullName: fullName };
    if (!displayFullName && !description)
        return (0, jsx_runtime_1.jsx)(exports.AvatarCircle, __assign({}, avatarProps));
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "squid-flex squid-items-center" }, { children: [(0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(exports.AvatarCircle, __assign({}, avatarProps)) }), (0, jsx_runtime_1.jsxs)("div", __assign({ className: "squid-ml-3" }, { children: [(0, jsx_runtime_1.jsx)(Typography_1.Label, __assign({ as: 'div', className: "squid-whitespace-nowrap squid-text-alias-color-text-base" }, { children: fullName })), (0, jsx_runtime_1.jsx)(Typography_1.Label, __assign({ strong: false, as: 'div', className: "squid-whitespace-nowrap squid-text-alias-color-text-weaker" }, { children: description }))] }))] })));
};
exports.Avatar = Avatar;
